// extracted by mini-css-extract-plugin
module.exports = {"page":"RootTemplate_page__daDPB","content":"RootTemplate_content__sz8jO"};